import { locales } from './locales'

export const translate = key => locales[key]
